import {
  toCamelCase,
  toConstantCase,
  toKebabCase,
  toNameWords,
} from './clientName';

// Caminho relativo a partir do settings.js, onde o código gerado é colado
const IMAGES_PATH = '../../../assets/images/personalized-invite';

const normalizeText = text => (text || '').replace(/\s+/g, ' ').trim();

const toStringLiteral = text =>
  `'${text.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`;

export const buildSettingsSnippet = ({
  clientName,
  personContextId,
  primaryColor,
  secondaryColor,
  logoExtension,
  bannerExtension,
  bannerFocus,
  hostMessage,
  condominiumNotice,
}) => {
  const words = toNameWords(clientName);
  const constantBase = `${toConstantCase(words)}_${personContextId}`;
  const variableBase = `${toCamelCase(words)}${personContextId}`;
  const fileBase = `${toKebabCase(words)}-${personContextId}`;

  const condominiumConstant = `${constantBase}_CONDOMINIUM`;
  const inviteConstant = `${constantBase}_PERSONALIZED_INVITE`;
  const logoVariable = `${variableBase}Logo`;
  const bannerVariable = `${variableBase}Banner`;
  const logoFileName = `${fileBase}-logo.${logoExtension}`;
  const bannerFileName = `${fileBase}-banner.${bannerExtension}`;

  const normalizedHostMessage = normalizeText(hostMessage);
  const normalizedNotice = normalizeText(condominiumNotice);

  const customizationLines = [
    `    primaryColor: '${primaryColor}',`,
    `    secondaryColor: '${secondaryColor}',`,
    `    logoUrl: ${logoVariable},`,
    `    bannerImageUrl: ${bannerVariable},`,
    bannerFocus > 0 && `    bannerPosition: 'center ${bannerFocus}%',`,
  ].filter(Boolean);

  const textLines = [
    normalizedHostMessage &&
      `  hostMessage: ${toStringLiteral(normalizedHostMessage)},`,
    normalizedNotice &&
      `  condominiumNotice: ${toStringLiteral(normalizedNotice)},`,
  ].filter(Boolean);

  const definitions = [
    `const ${condominiumConstant} = ${personContextId};`,
    '',
    `const ${inviteConstant} = {`,
    '  customization: {',
    ...customizationLines,
    '  },',
    ...textLines,
    '};',
  ].join('\n');

  const imports = [
    `import ${bannerVariable} from '${IMAGES_PATH}/${bannerFileName}';`,
    `import ${logoVariable} from '${IMAGES_PATH}/${logoFileName}';`,
  ].join('\n');

  return {
    imports,
    definitions,
    mapEntry: `[${condominiumConstant}]: ${inviteConstant},`,
    logoFileName,
    bannerFileName,
  };
};
